import { render, staticRenderFns } from "./RegisterQuestion.vue?vue&type=template&id=09c2774d&scoped=true&"
import script from "./RegisterQuestion.vue?vue&type=script&lang=js&"
export * from "./RegisterQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RegisterQuestion.vue?vue&type=style&index=0&id=09c2774d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2774d",
  null
  
)

export default component.exports